// we need to export using commonjs for ease of usage in all
// JavaScript environments

/* eslint-disable import/no-commonjs */

import widget from './src/instantsearch/widget.js';
module.exports = widget;



// WEBPACK FOOTER //
// ./instantsearchWidget.js